export enum EWalletEvent {
	ADMIN_ADJUST_CREDITS = 'admin_adjust_credits',
	ADMIN_ADJUST_DEBITS = 'admin_adjust_debits',
	B2B_WELCOME_BONUS = 'b2b_welcome_bonus',
	RESERVATION_CAPTURED = 'reservation_captured',
	RESERVATION_PLACED = 'reservation_placed',
	RESERVATION_RELEASED = 'reservation_released',
	WALLET_CREDITED = 'wallet_credited',
	WALLET_DEBITED = 'wallet_debited',
	WALLET_TOPPED_UP = 'wallet_topped_up',
	PROGRAM_800_CREDITED = 'program_800_credited',
	PROGRAM_800_CAPTURED = 'program_800_captured',
	PROGRAM_800_RELEASED = 'program_800_released',
	PROGRAM_800_SUSPENDED = 'program_800_suspended',
}

export enum EWalletType {
	TOP_UP = 'top_up',
	CASHBACK = 'cashback',
	PROMO = 'promo',
}

export const clientWalletEventLabels: Record<EWalletEvent, string> = {
	[EWalletEvent.ADMIN_ADJUST_CREDITS]: 'Korekta środków przez administratora',
	[EWalletEvent.ADMIN_ADJUST_DEBITS]: 'Korekta środków przez administratora',
	[EWalletEvent.B2B_WELCOME_BONUS]: 'Bonus powitalny B2B',
	[EWalletEvent.RESERVATION_CAPTURED]: 'Realizacja rezerwacji - pobranie środków',
	[EWalletEvent.RESERVATION_PLACED]: 'Rezerwacja środków',
	[EWalletEvent.RESERVATION_RELEASED]: 'Zwolnienie środków',
	[EWalletEvent.WALLET_CREDITED]: 'Środki dodane do portfela',
	[EWalletEvent.WALLET_DEBITED]: 'Środki pobrane z portfela',
	[EWalletEvent.WALLET_TOPPED_UP]: 'Doładowanie portfela',
	[EWalletEvent.PROGRAM_800_CREDITED]: 'Doładowanie Programu Foodowy 800+',
	[EWalletEvent.PROGRAM_800_CAPTURED]: 'Rozliczenie płatności z Programu Foodowy 800+',
	[EWalletEvent.PROGRAM_800_RELEASED]: 'Zwolnienie środków Programu Foodowy 800+',
	[EWalletEvent.PROGRAM_800_SUSPENDED]: 'Zawieszenie uczestnictwa w Programie Foodowy 800+',
}

export const clientWalletCreditEvents: EWalletEvent[] = [
	EWalletEvent.ADMIN_ADJUST_CREDITS,
	EWalletEvent.B2B_WELCOME_BONUS,
	EWalletEvent.WALLET_CREDITED,
	EWalletEvent.WALLET_TOPPED_UP,
	EWalletEvent.PROGRAM_800_CREDITED,
]

export const clientWalletDebitEvents: EWalletEvent[] = [
	EWalletEvent.ADMIN_ADJUST_DEBITS,
	EWalletEvent.RESERVATION_CAPTURED,
	EWalletEvent.WALLET_DEBITED,
	EWalletEvent.PROGRAM_800_CAPTURED,
]

export const clientWalletActorLabels: Record<string, string> = {
	employee: 'Pracownik',
	client: 'Klient',
	system: 'System',
	admin: 'Admin',
}

export const clientWalletCoverageLabels: Record<EWalletType, string> = {
	[EWalletType.TOP_UP]: 'FoodiKarta',
	[EWalletType.CASHBACK]: 'Cashback',
	[EWalletType.PROMO]: 'Program Foodowy 800+',
}

export const clientWalletCoverageIcons: Record<EWalletType, string> = {
	[EWalletType.TOP_UP]: 'money',
	[EWalletType.CASHBACK]: 'points',
	[EWalletType.PROMO]: 'percentCircle',
}
